import Column from '@components/Column';
import Radio from '@components/Radio';
import TextField from '@components/TextField';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import SectionTitle from '../common/SectionTitle';

function OrderNote() {
    const { requestMessages } = useAppCustom().payment;
    const { note } = useCalculatedRequest();
    const dispatch = useDispatch();
    const { t } = useTranslation('order');
    const messages = requestMessages
        .filter((message) => !!message);
    // 저장해 둔 요청사항이 준비된 문구가 아니면 직접입력 상태로 시작한다
    const [isManual, setIsManual] = useState<boolean>(!!note && !messages.includes(note));
    const updateNote = (v: string) => {
        dispatch(orderActions.setNote(v));
    };
    return (
        <Container fullWidth spacing={4}>
            <SectionTitle>{t('orderNote.title')}</SectionTitle>
            <Column fullWidth>
                {messages.map((message, index) => (
                    <Option key={index.toString()}>
                        <Radio value={message}
                            onChange={(v) => {
                                updateNote(v);
                                setIsManual(false);
                            }}
                            isSelected={note === message && !isManual} >
                            {message}
                        </Radio>
                    </Option>
                ))}
                <Option>
                    <Radio value='none'
                        isSelected={!note && !isManual}
                        onChange={() => {
                            updateNote('');
                            setIsManual(false);
                        }}>
                        {t('orderNote.noSelection')}
                    </Radio>
                </Option>
                <Option>
                    <Radio value='manual'
                        isSelected={isManual}
                        onChange={() => {
                            setIsManual(true);
                            updateNote('');
                        }} >
                        {t('orderNote.manual')}
                    </Radio>
                </Option>
                {isManual && (
                    <TextField value={note}
                        placeholder={t('orderNote.placeholder')}
                        as='textarea'
                        rows={3}
                        onChange={(e) => updateNote(e.target.value)} />
                )}
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
`;

const Option = styled.div`
    padding: var(--spacing-2) 0;
    width: 100%;
`;

export default OrderNote;
